
import React, { useEffect, useMemo, useState } from 'react';
import './Obras.css';
import { obras } from '../../json/obras'

const formatoMoneda = new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 2
});

const Reconstruccion2025 = () => {
    const [anio, setAnio] = useState(2024);
    const [busqueda, setBusqueda] = useState('');
    const [pagina, setPagina] = useState(1);
    const [porPagina, setPorPagina] = useState(10);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const obrasFiltradas = useMemo(() => {
        const texto = busqueda.trim().toLocaleLowerCase('es-MX');

        if (!texto) return obras;

        return obras.filter((obra) =>
            [
                obra.num,
                obra.dependencia,
                obra.municipio,
                obra.nombre,
                obra.monto,
                obra.estatus,
                obra.fase
            ]
                .join(' ')
                .toLocaleLowerCase('es-MX')
                .includes(texto)
        );
    }, [busqueda]);

    const totalPaginas = Math.max(
        1,
        Math.ceil(obrasFiltradas.length / porPagina)
    );

    const obrasVisibles = obrasFiltradas.slice(
        (pagina - 1) * porPagina,
        pagina * porPagina
    );

    const primerRegistro = obrasFiltradas.length
        ? (pagina - 1) * porPagina + 1
        : 0;

    const ultimoRegistro = Math.min(
        pagina * porPagina,
        obrasFiltradas.length
    );

    const cambiarBusqueda = (valor) => {
        setBusqueda(valor);
        setPagina(1);
    };

    const cambiarAnio = (nuevoAnio) => {
        setAnio(nuevoAnio);
        setPagina(1);
        setBusqueda('');

        // Aquí puedes cargar los registros del año seleccionado.
    };

    return (
        <main className="obras-page">
            {/*<header className="obras-brand">*/}
            {/*    <div className="obras-brand-text">*/}
            {/*        <strong>HIDALGO | INFRAESTRUCTURA PÚBLICA</strong>*/}
            {/*        <small>*/}
            {/*            SECRETARÍA DE INFRAESTRUCTURA PÚBLICA*/}
            {/*            Y DESARROLLO URBANO SOSTENIBLE*/}
            {/*        </small>*/}
            {/*    </div>*/}
            {/*</header>*/}

            <h1 className="obras-title">
                Reconstrucción Vaguada Monzónica
            </h1>

            <section className="obras-toolbar">
                <div className="obras-years">
                    {/*<button*/}
                    {/*    type="button"*/}
                    {/*    className="obras-year active"*/}
                    {/*    disabled*/}
                    {/*>*/}
                    {/*    2025*/}
                    {/*</button>*/}
                </div>

                <div className="obras-search">
                    <input
                        type="search"
                        placeholder="Búsqueda rápida"
                        aria-label="Buscar obras"
                        value={busqueda}
                        onChange={(e) => cambiarBusqueda(e.target.value)}
                    />

                    <button
                        type="button"
                        className="obras-refresh"
                        title="Restablecer búsqueda"
                        onClick={() => cambiarBusqueda('')}
                    >
                        ⟳
                    </button>
                </div>
            </section>

            <section className="obras-table-card">
                <div className="obras-table-scroll">
                    <table className="obras-table">
                        <thead>
                        <tr>
                            <th>NO.</th>
                            <th>DEPENDENCIA</th>
                            <th>MUNICIPIO</th>
                            <th>NOMBRE</th>
                            <th>MONTO</th>
                            <th>ESTATUS</th>
                            {/*<th>FASE</th>*/}
                        </tr>
                        </thead>

                        <tbody>
                        {obrasVisibles.map((obra) => (
                            <tr key={obra.num}>
                                <td>{obra.num}</td>
                                <td>{obra.dependencia}</td>
                                <td>{obra.municipio}</td>
                                <td className="obra-nombre">{obra.nombre}</td>
                                <td className="no-wrap">
                                    {obra.monto === '' || obra.monto == null
                                        ? '—'
                                        : Number(obra.monto).toLocaleString('es-MX', {
                                            style: 'currency',
                                            currency: 'MXN',
                                            minimumFractionDigits: 2
                                        })}
                                </td>
                                <td>{obra.estatus}</td>
                                {/*<td>{obra.fase}</td>*/}
                            </tr>
                        ))}
                        </tbody>
                    </table>

                    {obrasFiltradas.length === 0 && (
                        <div className="obras-empty">
                            No se encontraron registros.
                        </div>
                    )}
                </div>
            </section>

            <footer className="obras-footer">
        <span>
          Mostrando {primerRegistro} a {ultimoRegistro} de{' '}
            {obrasFiltradas.length} filas.
        </span>

                <label className="obras-page-size">
                    <select
                        value={porPagina}
                        onChange={(e) => {
                            setPorPagina(Number(e.target.value));
                            setPagina(1);
                        }}
                        aria-label="Registros por página"
                    >
                        {[10, 25, 50, 100].map((cantidad) => (
                            <option key={cantidad} value={cantidad}>
                                {cantidad}
                            </option>
                        ))}
                    </select>
                    registros por página.
                </label>

                {totalPaginas > 1 && (
                    <nav className="obras-pagination" aria-label="Paginación">
                        <button
                            type="button"
                            disabled={pagina === 1}
                            onClick={() => setPagina((p) => p - 1)}
                        >
                            ‹
                        </button>

                        {Array.from(
                            { length: totalPaginas },
                            (_, i) => i + 1
                        ).map((numero) => (
                            <button
                                type="button"
                                key={numero}
                                className={pagina === numero ? 'active' : ''}
                                onClick={() => setPagina(numero)}
                            >
                                {numero}
                            </button>
                        ))}

                        <button
                            type="button"
                            disabled={pagina === totalPaginas}
                            onClick={() => setPagina((p) => p + 1)}
                        >
                            ›
                        </button>
                    </nav>
                )}
            </footer>
        </main>
    );
};

export default Reconstruccion2025;
